import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { PerfilRiesgo } from '../../_models/perfil-riesgo';
import { PerfilRiesgoService } from '../../_services/perfil-riesgo.service';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaItem } from '../../_models/lista-item';

@Component( {
  selector: 'app-perfiles-riesgo-listado',
  templateUrl: 'perfiles-riesgo-listado.component.html'
} )

export class PerfilesRiesgoListadoComponent implements OnInit {

  perfiles: PerfilRiesgo[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private perRiesgoServicio: PerfilRiesgoService, private navServicio: NavService, private router: Router, private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/perfiles-riesgo' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'id', header: this.navServicio.buscarMensaje( 'PERFILRIESGO.LBL_ID' ), sort: false },
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'PERFILRIESGO.LBL_CODIGO' ), sort: false },
      { field: 'nombreRiesgo', header: this.navServicio.buscarMensaje( 'PERFILRIESGO.LBL_RIESGO' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'orden', header: this.navServicio.buscarMensaje( 'LBL_ORDEN' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'perfiles-riesgo.component' );

    this.perRiesgoServicio.listado().subscribe( perfiles => {
      this.perfiles = perfiles.sort( ( a, b ) => {
        return a.orden - b.orden;
      } );
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/perfiles-riesgo/agregar' ] );
  }

  ver( perfil: PerfilRiesgo ) {
    this.router.navigate( [ 'apl/perfiles-riesgo/detalle/' + perfil.idPerfilRiesgo ] );
  }

  editar( perfil: PerfilRiesgo ) {
    this.router.navigate( [ 'apl/perfiles-riesgo/actualizar/' + perfil.idPerfilRiesgo ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'perfiles-riesgo.component', this.busqueda );
  }

  sendBefore( item: PerfilRiesgo ) {
    let myIndex = this.perfiles.indexOf( item );
    if ( myIndex < this.perfiles.length - 1 ) {
      this.carTabla = true;
      let newOrder = this.perfiles[ myIndex ].orden;
      this.perfiles[ myIndex ].orden = this.perfiles[ myIndex + 1 ].orden;
      this.perRiesgoServicio.actualizar( this.perfiles[ myIndex ] ).subscribe( data => {
        this.perfiles[ myIndex + 1 ].orden = newOrder;
        this.perRiesgoServicio.actualizar( this.perfiles[ myIndex + 1 ] ).subscribe( res => {
          this.sortItems();
          this.carTabla = false;
        } );
      } );
    }
  }

  /**
   * Ordena los item de una lista y actualiza el campo de orden.
   * @param {ListaItem} item
   */
  sendAfter( item: PerfilRiesgo ) {
    let myIndex = this.perfiles.indexOf( item );
    if ( myIndex > 0 ) {
      this.carTabla = true;
      let newOrder = this.perfiles[ myIndex ].orden;
      this.perfiles[ myIndex ].orden = this.perfiles[ myIndex - 1 ].orden;
      this.perRiesgoServicio.actualizar( this.perfiles[ myIndex ] ).subscribe( data => {
        this.perfiles[ myIndex - 1 ].orden = newOrder;
        this.perRiesgoServicio.actualizar( this.perfiles[ myIndex - 1 ] ).subscribe( res => {
          this.sortItems();
          this.carTabla = false;
        } );

      } );
    }
  }

  sortItems() {
    const lista = this.perfiles.sort( ( a, b ) => {
      return a.orden - b.orden;
    } );
    this.perfiles = lista;
  }

  mostrarAbajo( item ) {
    const ordenes = [];
    this.perfiles.map( x => {
      ordenes.push( x.orden );
    } );
    const orden = Math.max( ...ordenes );
    return orden !== item.orden;
  }

  mostrarArriba( item ) {
    const ordenes = [];
    this.perfiles.map( x => {
      ordenes.push( x.orden );
    } );
    const orden = Math.min( ...ordenes );
    return orden !== item.orden;
  }
}
